package org.tlsys.goods

import org.tlsys.json.JsonFactory

const val GOODS_SERVICE_INVOCATOR = "Goods Admin Extension"

const val GOODS_HISTORY_SERVICE = "goods_history_service"
const val GOOD_DICTIONARY_SERVICE = "goods_dictionary_service"
const val GOODS_SERVICE = "GOODS_SERVICE"
const val GOOD_IMPORT_SERVICE = "goods_import_service"